module.exports = __webpack_public_path__ + "img/Share_hover_en.2ccc69c0.svg";